import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/pro-light-svg-icons';

import { enrollmentCheckChequeStrings } from 'utils/enrollmentCheckChequeStrings';

import { Btn } from 'components/btn/Btn';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import { NumberedStep } from './NumberedStep';
import { UploadCheckModal } from './UploadCheckModal';

export const UploadVoidedCheck = () => {
    const [isOpen, toggle] = useModalControls();
    const [isCopied, copyText] = useCopyToClipboard();

    return (
        <NumberedStep number={2}>
            <Btn data-testid="upload-check-btn" onClick={toggle}>
                {enrollmentCheckChequeStrings.uploadCta}
            </Btn>
            <p>
                <span className="text-grey-2 font-semibold mr-1">or</span>
                {enrollmentCheckChequeStrings.emailCopyPrefix}{' '}
                <a
                    className="ml-1"
                    href={`mailto:${enrollmentCheckChequeStrings.fundraisingEmail}`}
                >
                    {enrollmentCheckChequeStrings.fundraisingEmail}
                </a>
                {!isCopied ? (
                    <FontAwesomeIcon
                        onClick={() => copyText(enrollmentCheckChequeStrings.fundraisingEmail)}
                        className="text-brand ml-1 cursor-pointer"
                        icon={faCopy}
                        size="xs"
                    />
                ) : (
                    <FontAwesomeIcon
                        className="text-brand ml-1 cursor-pointer"
                        icon={faCheck}
                        size="xs"
                    />
                )}
            </p>
            <UploadCheckModal isOpen={isOpen} onClose={toggle} />
        </NumberedStep>
    );
};

const useModalControls = (): [boolean, () => void] => {
    const [isOpen, onClose_] = useState<boolean>(false);
    const toggle = () => onClose_((value) => !value);
    return [isOpen, toggle];
};
